<template>
  <div v-if="tags.length > 0" class="tags">
    <router-link
      :to="'/blog?tag=' + encodeURI(tag)"
      v-for="tag in tags"
      v-bind:key="tag"
      class="tag"
    >{{tag}}</router-link>
  </div>
</template>

<script>
export default {
  name: "blog-tags",
  props: {
    tags: {
      type: Array,
      description: "Tags."
    }
  }
};
</script>

<style scoped lang="scss">
.tags {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  .tag {
    padding: 0 0.4rem;
    border-radius: 3px;
    background-color: #adadad;
    color: white;
    margin: 0.25rem 0.25rem;
    font-size: 0.875rem;

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
